module.exports = __webpack_public_path__ + "static/media/minus-square.a40f3b18.svg";